import { useCoreSelector } from '../../CoreStore';

export const useMiniLobbySlice = {
  getIsIframeLoaded: (): boolean => {
    return useCoreSelector(({ minilobby }) => minilobby.isIframeLoaded);
  },
  getIsLobbyFullscreen: (): boolean => {
    return useCoreSelector(({ minilobby }) => minilobby.isLobbyFullscreen);
  },
};
